<template>
  <v-container fluid>
      <material-card
      color="primary"
      title="Daftar Arsip Dokumen"
      class="card-wrapper"
      >
      <form>
          <esign-filter-panel>
          <div style="height: 80px" class="form-input row">
              <div v-if="peran!='A02'" class="col-3">
              <p class="label font-weight-bold mb-1">Username Pengaju</p>
              <v-text-field
                  v-model="searchForm.username_pengaju"
                  placeholder="Username Pengaju"
                  dense
                  outlined
              />
              </div>
              <div v-if="peran!='A03'" class="col-3">
              <p class="label font-weight-bold mb-1">Nama Penandatangan</p>
              <v-text-field
                  v-model="searchForm.nama_penandatangan"
                  placeholder="Nama Penandatangan"
                  dense
                  outlined
              />
              </div>
              <div class="col-3">
              <p class="label font-weight-bold mb-1">Nomor Surat</p>
              <v-text-field
                  outlined
                  placeholder="Nomor Surat"
                  clearable
                  dense
                  v-model="searchForm.nomor_surat"
              /> 
              </div>
              <div class="col-3">
              <p class="label font-weight-bold mb-1">Tanggal Pengajuan</p>
              <v-text-field
                  type="date"
                  outlined
                  clearable
                  dense
                  v-model="searchForm.tanggal_pengajuan"
              /> 
              </div>
          </div>
          <div style="height: 80px" class="form-input row">
              <div class="col-4">
              <p class="label font-weight-bold mb-1">Jenis Dokumen</p>
              <v-autocomplete
                  :items="filteredJenisDokumen"
                  :item-text="item => item.nama"
                  :item-value="item => item.id"
                  no-data-text="Tidak ada data"
                  placeholder="Pilih Jenis Dokumen"
                  clearable
                  dense
                  outlined
                  v-model="searchForm.id_jenis_dokumen"
                  @keydown.enter.prevent
              ></v-autocomplete>
              </div>
              <div class="col-4">
              <p class="label font-weight-bold mb-1">Status Dokumen</p>
              <v-select
                  :items="statusDokumens"
                  :item-text="item => item.nama"
                  :item-value="item => item.id"
                  no-data-text="Tidak ada data"
                  placeholder="Pilih Status Dokumen"
                  clearable
                  dense
                  outlined
                  v-model="searchForm.id_status_dokumen"
                  @keydown.enter.prevent
              ></v-select>
              </div>
              <div class="col-4">
              <p class="label font-weight-bold mb-1"><br></p>
              <v-btn
                  color="primary"
                  class="mr-4"
                  @click="searchDokumen()"
              >
                  Cari
              </v-btn>
              </div>
          </div>
          </esign-filter-panel>
          <br>
      </form>
      <v-card>
          <div class="row ma-0 align-center">
          <div class="col-8">
          <v-text-field
          v-model="search"
          class="esign-table-search"
          prepend-inner-icon="mdi-magnify"
          label="Cari di halaman ini"
          outlined
          dense
          clearable
          single-line
          hide-details
        ></v-text-field>
          </div>
          <div class="col-4 text-right">
              <v-btn
                  depressed
                  color="primary"
                  :disabled="selected.length == 0"
                  :loading="isDownloading"
                  @click="downloadZip()"
              >
                  <v-icon left small>mdi-download</v-icon>Download ZIP ({{ selected.length }})
              </v-btn>
          </div>
          </div>

          <!-- Paginated by the backend (10 rows per page); the search box filters the rows of the current page.
               The selection is kept across pages; unfinished documents are marked with their status in the zip -->
          <v-data-table
              v-model="selected"
              show-select
              item-key="id_arsip"
              :headers="filteredHeaders"
              :items="pageItems"
              no-results-text="Data tidak ditemukan"
              no-data-text="Tidak ada data"
              class="elevation-1"
              :loading="isLoading"
              loading-text="Memuat data..."
              :options.sync="options"
              :server-items-length="totalData"
              hide-default-footer
              disable-sort
          >
            <template v-slot:footer="{ props, on }">
              <esign-table-footer
              :pagination="props.pagination"
              :options="props.options"
              @update:options="on['update:options']"
              />
            </template>
            <template v-slot:item.status_dokumen="{ item }">
              <esign-status-tag :value="item.status_dokumen" />
            </template>
              <template
                  v-for="header in filteredHeaders.filter((header) =>
                  header.hasOwnProperty('formatter')
                  )"
                  v-slot:[`item.${header.value}`]="{ header, value }"
              >
                  {{ header.formatter(value) }}
              </template>
              <template v-slot:item.action="{ item }">
              <v-row>
                  <!-- <v-checkbox v-if="verify_bulk" @click="tick(item)"></v-checkbox> -->
                  <v-btn style="margin:auto" small color="primary" dark @click="detailItem(item)">Detail</v-btn>
              </v-row>
              </template>
          </v-data-table>

          <!-- <div class="row" v-if="verify_bulk">
          <div class="col-2">
              <h4 dense class="label" style="padding-top:0.5em">Input Passphrase</h4>
          </div>
          <div class="col-3">
              <v-text-field
                  v-model="signForm.passphrase"
                  dense
                  clearable
                  outlined
              />
          </div>
          <div class="col-2">
              <v-btn style="min-width:120px" color="green" @click="sign()">Tanda tangan</v-btn> 
          </div>
          </div> -->
      </v-card>
      <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="8000" :top="true">
        {{ snackbarText }}
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      </material-card>
  </v-container>
</template>

<script>
import rememberListState from "@/mixins/rememberListState";
import { apiServer } from "../../setup-axios";
var moment = require('moment');
export default {
  mixins: [rememberListState],
  // filters/search/page kept when returning from a detail page
  rememberState: ["tab", "search", "searchBatch", "searchForm", "searchFormBatch", "options", "nomor_halaman", "totalData", "appliedSearch"],
  onListStateRestored() {
    // keep the restored page instead of jumping back to page 1
    this.getDataSource = ""
  },
data: () => ({
  tab:null,
  search: "",
  searchBatch: "",
  snackbar: false,
  snackbarText: "",
  snackbarColor: "",
  isLoading: true, 
  jenisDokumens: [],
  statusDokumens: [],
  items: [],
  itemsBatch: [],
  // rows ticked for the zip download
  selected: [],
  isDownloading: false,
  // headers: [],
  searchForm: {
      username_pengaju_login: "",
      id_penandatangan_login: -1,
      nama_penandatangan: "",
      username_pengaju: "",
      nomor_surat: "",
      tanggal_pengajuan: null,
      id_jenis_dokumen: -1,
      id_status_dokumen: 3,
      organisasi: -1
  },
  searchFormBatch : {
      username_pengaju_login: "",
      id_penandatangan_login: -1,
      nama_penandatangan: "",
      username_pengaju: "",
      batch_name: "",
      tanggal_pengajuan: null,
      id_jenis_dokumen: -1,
      id_status_dokumen: 3,
      organisasi: -1
  }, 
  options: {},
  optionsBatch: {},
  totalData: 0,
  totalDataBatch: 0,
  tgl:null, 
  peran: "",
  user: null,
  nomor_halaman: 1,
  getDataSource: "search",
  // filters applied with "Cari"; paging always uses these, never half-edited form values
  appliedSearch: null,
  // sortOrder: 'asc',
  // sortBy: 'tanggal_pengajuan',
}),
computed: {
  pageItems() {
    // the table is paginated by the backend, so the quick search filters the current page
    const q = (this.search || '').toString().trim().toLowerCase()
    if (!q) return this.items
    const keys = this.filteredHeaders.map(h => h.value).filter(v => v !== 'action')
    return this.items.filter(item => keys.some(k => item[k] != null && String(item[k]).toLowerCase().includes(q)))
  },
  filteredJenisDokumen(){
      return this.jenisDokumens.filter(item => item.status)
  },
  filteredStatusDokumen(){
      return this.statusDokumens.filter(item => item.id != 5)
  },
  filteredHeaders() {
    const headers = [
      { text: "Nomor Pengajuan", value: "nomor_pengajuan", cellClass: "esign-cell-break" },
      { text: "Tanggal Pengajuan", value: "tanggal_pengajuan", sortable: true, formatter: (x) => (x ? moment.utc(x).locale("id").format('DD-MM-YYYY HH:mm:ss') : null), },
      { text: "Nomor Surat", value: "nomor_surat", cellClass: "esign-cell-break" },
      { text: "Jenis Dokumen", value: "nama_jenis_dokumen"},
      { text: "Nama Organisasi", value: "nama_organisasi"},
      { text: "Username Pengaju", value: "username_pengaju"},
      { text: "Status", value: "status_dokumen"},
      { text: "Aksi", align:"center", value: "action", sortable: false}
    ]
    // if(this.peran!='A03') {
    //   headers.push(
    //     { text: "Nama Penandatangan", value: "nama_penandatangan"}
    //   )
    // }
    // headers.push(
    //   { text: "Username Pengaju", value: "username_pengaju"},
    //   { text: "Status", value: "status_dokumen"},
    //   { text: "Aksi", align:"center", value: "action", sortable: false}
    // )
    return headers
  },
  filteredHeadersBatch() {
    const headers = [ 
      { text: "Nama Batch", value: "batch_name" },
      { text: "Tanggal Pengajuan", value: "tanggal_pengajuan", sortable: true, formatter: (x) => (x ? moment.utc(x).locale("id").format('DD-MM-YYYY HH:mm:ss') : null), },
      { text: "Jenis Dokumen", value: "nama_jenis_dokumen"},
      { text: "Nama Organisasi", value: "nama_organisasi"},
      { text: "Source", value: "source"},
      { text: "Username Pengaju", value: "username_pengaju"},
      { text: "Status", value: "status_dokumen"},
      { text: "Aksi", align:"center", value: "action", sortable: false}
    ]
    // if(this.peran!='A03') {
    //   headers.push(
    //     { text: "Nama Penandatangan", value: "nama_penandatangan"}
    //   )
    // }
    // headers.push(
    //   { text: "Username Pengaju", value: "username_pengaju"},
    //   { text: "Status", value: "status_dokumen"},
    //   { text: "Aksi", align:"center", value: "action", sortable: false}
    // )
    return headers
  }
},
watch: {
  options: {
    handler(val) {
      const page = (val && val.page) || 1
      if (page !== this.nomor_halaman) {
        this.nomor_halaman = page
        this.getDataSource = ""
      }
      this.getData()
      // this.getDataBatch()
    },
    deep: true
  },
},

created() {
  this.peran =localStorage.getItem("currentPeran"),
  this.user= JSON.parse(localStorage.getItem("user"))
  if (this.$store.state.snackbar.snackbarText != null) {
    this.showMessage()
  }
  this.getDropdownJenisDokumen()
  this.getDropdownStatusDokumen()
  // console.log(localStorage.getItem("currentPeran"));
},
methods: {
  getData() {
    const f = this.appliedSearch || (this.appliedSearch = JSON.parse(JSON.stringify(this.searchForm)))
    this.isLoading = true;
    console.log("search form", JSON.stringify(this.searchForm));
    let tanggal_pengajuan = null
    if (f.tanggal_pengajuan) {
      tanggal_pengajuan = moment(f.tanggal_pengajuan).format('DD-MM-YYYY')
    }
    if (this.peran=='A03') {
      f.id_penandatangan_login = this.user.id
    }
    if (this.peran=='A02') {
      f.username_pengaju_login = this.user.username
    }
    if (this.getDataSource == "search") {
      this.totalData = 0
    }
    apiServer
      .get("/arsip/arsip_list", {
        params: {
          nomor_surat: f.nomor_surat,
          username_pengaju: f.username_pengaju,
          nama_penandatangan: f.nama_penandatangan,
          id_jenis_dokumen: f.id_jenis_dokumen,
          tanggal_pengajuan: tanggal_pengajuan,
          id_status_dokumen: f.id_status_dokumen,
          id_penandatangan_login: f.id_penandatangan_login,
          username_pengaju_login: f.username_pengaju_login,
          nomor_halaman: this.nomor_halaman,
          ukuran_halaman: this.options.itemsPerPage || 10,
          total_data: this.totalData,
          id_organisasi: this.searchFormBatch.organisasi
        }
      })
      .then(response => {
        this.isLoading = false;
        this.items = response.data.data;
        this.totalData = response.data.total
        if (this.getDataSource == "search") {
          this.nomor_halaman = 1
        }
        this.getDataSource = ""
      })
      .catch(error => {
        console.log("There was an error:", error.response); // Logs out the error
        this.isLoading = false;
      });
  },
  getDropdownJenisDokumen() {
    apiServer
      .get("/arsip/dropdown_jenis_dok")
      .then(response => {
        this.jenisDokumens = response.data.data;
      })
      .catch(error => {
        console.log("There was an error:", error.response.data.message); // Logs out the error
      });
  },
  getDropdownStatusDokumen() {
    apiServer
      .get("/arsip/dropdown_status_dok")
      .then(response => {
        // console.log("status: "+ JSON.stringify(response.data.data))
        this.statusDokumens = response.data.data;
      })
      .catch(error => {
        console.log("There was an error:", error.response.data.message); // Logs out the error
      });
  },
  getDataBatch() { 
  //   console.log("searchFormBatch", JSON.stringify(this.searchFormBatch));
    let tanggal_pengajuan = null
    if (this.searchFormBatch.tanggal_pengajuan) {
      tanggal_pengajuan = moment(this.searchFormBatch.tanggal_pengajuan).format('DD-MM-YYYY')
    }
    if (this.peran=='A03') {
      this.searchFormBatch.id_penandatangan_login = this.user.id
    }
    if (this.peran=='A02') {
      this.searchFormBatch.username_pengaju_login = this.user.username
    } 
    apiServer
      .get("/batch/list", {
        params: {
          batch_name: this.searchFormBatch.batch_name,
          username_pengaju: this.searchFormBatch.username_pengaju,
          nama_penandatangan: this.searchFormBatch.nama_penandatangan,
          id_jenis_dokumen: this.searchFormBatch.id_jenis_dokumen,
          tanggal_pengajuan: tanggal_pengajuan,
          id_status_dokumen: this.searchFormBatch.id_status_dokumen,
          id_penandatangan_login: this.searchFormBatch.id_penandatangan_login,
          username_pengaju_login: this.searchFormBatch.username_pengaju_login,
          id_organisasi: this.searchFormBatch.organisasi
        }
      })
      .then(response => { 
        this.itemsBatch = response.data.data;
        this.totalDataBatch = response.data.total 
      })
      .catch(error => {
        console.log("There was an error:", error.response); // Logs out the error 
      });
  },
  showSnackbar(color, message) {
    console.log("snack " + color + " - " + message);
    this.snackbar = true;
    this.snackbarText = message;
    this.snackbarColor = color;
  },
  showMessage () {
    this.showSnackbar(
        this.$store.state.snackbar.snackbarColor,
        this.$store.state.snackbar.snackbarText
    )
    this.$store.dispatch('setSnackbar', {
      snackbarColor: null,
      snackbarText: null,
    })
  },
  searchDokumen(){
    console.log("search"+JSON.stringify(this.searchForm))
    // this.search = ""
    if (!this.searchForm.id_jenis_dokumen) {
      this.searchForm.id_jenis_dokumen = -1
    }
    if (!this.searchForm.id_status_dokumen) {
      this.searchForm.id_status_dokumen = -1
    }
    this.appliedSearch = JSON.parse(JSON.stringify(this.searchForm))
    this.selected = []
    this.getDataSource = "search"
    this.nomor_halaman = 1
    if (this.options.page && this.options.page !== 1) {
      this.options = Object.assign({}, this.options, { page: 1 }) // the options watcher fetches
    } else {
      this.getData()
    }
  },
  detailItem(item) {
    this.$router.push('/dokumen/detail/'+item.id_arsip);
  },
  downloadZip() {
    this.isDownloading = true
    apiServer
      .post("/arsip/download_zip", { id_arsip: this.selected.map(item => item.id_arsip) }, { responseType: "blob" })
      .then(response => {
        const disposition = response.headers["content-disposition"] || ""
        const match = disposition.match(/filename="?([^"]+)"?/)
        const url = window.URL.createObjectURL(new Blob([response.data], { type: "application/zip" }))
        const link = document.createElement('a')
        link.href = url
        // the header is not readable cross-origin (not exposed by CORS), so fall back to the same name format
        link.setAttribute('download', match ? match[1] : 'dokumen_' + moment().format('YYYYMMDD_HHmmss') + '.zip')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
        this.selected = []
      })
      .catch(async error => {
        // the error body is a blob too because of responseType
        let message = "Gagal mengunduh dokumen"
        try {
          message = JSON.parse(await error.response.data.text()).message || message
        } catch (e) {
          console.log("There was an error:", error)
        }
        this.showSnackbar("error", message)
      })
      .finally(() => {
        this.isDownloading = false
      })
  },
  searchDokumenBatch(){
  //   console.log("searchFormBatch with Form"+JSON.stringify(this.searchFormBatch))
    if (!this.searchFormBatch.id_jenis_dokumen) {
      this.searchFormBatch.id_jenis_dokumen = -1
    }
    if (!this.searchFormBatch.id_status_dokumen) {
      this.searchFormBatch.id_status_dokumen = -1
    } 
    this.searchBatch = ""
    this.optionsBatch.page = 1
    this.getDataBatch()
  },
  detailBatch(item) {
    this.$router.push('/batch/detail/'+item.id_batch);
  }
}
};
</script>